<script setup lang="ts">
interface Props {
  width?: number;
  height?: number;
}

withDefaults(defineProps<Props>(), {
  width: 24,
  height: 24,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 10v4a1 1 0 0 0 1 1h2l11 5V4L6 9H4a1 1 0 0 0-1 1z" />
    <path d="M7 15v3a2 2 0 0 0 4 0v-1.5" />
    <path d="M19 9a3 3 0 0 1 0 6" />
  </svg>
</template>
